import { Controller } from 'stimulus';
// import Flickity from 'flickity-hash'

export default class extends Controller {
  static targets = ['input'];

  connect() { // eslint-disable-line class-methods-use-this
    // const thisController = this;

    // new Flickity(this.carouselTarget, {
    //   draggable: true,
    //   cellAlign: 'left',
    //   freeScroll: false,
    //   wrapAround: true,
    //   //initialIndex: '#' + this.selectedTarget.id,
    //   hash: true,
    //   imagesLoaded: true,
    //   adaptiveHeight: true,
    //   prevNextButtons: this.options['showPrevNextButtons'],
    //   on: {
    //     change: function( index ) {
    //       var selectedNavId = thisController.getSelectedNavId(thisController.carouselTarget);
    //       thisController.markSelected(document.getElementById(selectedNavId));
    //     }
    //   }
    // });
    // var selectedNavId = this.getSelectedNavId(this.carouselTarget);
    // this.markSelected(document.getElementById(selectedNavId));
    console.log(this.inputTargets)
    console.log(this.minDate);
    this.inputTargets.forEach((el, index) => {
      console.log(el)
      console.log($(".flatpickr"))
      el.flatpickr( {
        dateFormat: "Y-m-d",
        minDate: this.minDate
      });
    });
    // $(".flatpickr").flatpickr( {
    //   dateFormat: "Y-m-d",
    //   minDate: this.minDate
    // });
  }

  // selectTab(event) {
  //   this.markSelected(event.currentTarget);
  // }

  // markSelected(element) {
  //   this.navTargets.forEach((el, index) => {
  //     el.classList.add('text-muted');
  //   });
  //   element.classList.remove('text-muted');
  // }

  // getSelectedNavId(carousel) {
  //   return Flickity.data(carousel).selectedCell.element.dataset.navId;
  // }

  // get options() {
  //   const options = this.element.dataset.options;
  //   return options ? JSON.parse(options) : null;
  // }

  get minDate() {
    return this.data.get("minDate");
  }
}
